import React from "react";
import logo from "../../assets/logo2.svg";
import damDiscovery from "../../assets/DamDiscovery.svg";
import angle from "../../assets/Angle.png";

export default function Hero({ onStart }) {
  return (
    <section className="hero">
      <div className="hero-inner">
        <div>
          <p className="wordmark">
            <img src={logo} alt="DAM Journey" />
          </p>

          <h1>Where does your organization actually stand on digital asset readiness?</h1>

          <p>
            A five-question check on how your team stores, tags, and governs assets today
            — before you sink budget into selecting or implementing a platform.
          </p>

          <button className="start-btn" onClick={onStart}>
            Start your 2-minute check
          </button>

          <div className="hero-meta">No email required to see your result.</div>
        </div>

        <div className="angleui">
          <img className="infographic" src={damDiscovery} alt="Dam Discovery" />
          <img className="angleSpin" src={angle} alt="Dam Discovery" />
        </div>
      </div>
    </section>
  );
}
